import React, { useEffect, useState } from "react"
import { Form, Button } from "react-bootstrap"
import _ from "lodash"
import { FormattedMessage } from "react-intl"

import { getServerlessObjects, getServerlessToken } from "../../../../Loaders"
import { withFermManagementConfig } from "../../../../config/FermManagementConfigProvider"
import { withApplicationConfig } from "../../../shared_components_registration"
import { logToServer } from "../../../../ErrorBoundary"

const updateExternalOptions = (
  searchInput,
  externalParent,
  buildServerlessQuery,
  externalParents,
  setExternalParents,
  url,
  username,
  password,
  setIsResultsLoading,
  setIsNoResults,
  setErr,
) => {
  let objectQuery
  let data

  const alphaNumericsOnly = searchInput.replace(/[^a-zA-Z0-9, ]/g, "")
  objectQuery = buildServerlessQuery(alphaNumericsOnly, externalParent)
  const genericNoResults = (msg) => {
    setIsNoResults(true)
    setIsResultsLoading(false)
    if (msg) {
      setErr(msg)
      console.error(msg)
      logToServer(msg)
    }
  }

  if (_.isNull(objectQuery)) {
    genericNoResults("There was a problem building the query")
  } else {
    getServerlessToken(url, username, password).then((token) => {
      if (token) {
        setErr(null)
        getServerlessObjects(objectQuery, token, url, username, password).then((results) => {
          if (results && !results?.errors) {
            if (["external_samples", "external_runs"].includes(externalParent)) {
              data =
                externalParent === "external_samples"
                  ? results.connectorBioControlSamples
                  : results.connectorBioControlRuns
              setExternalParents(data || [])
              setIsNoResults(data.length === 0)
              setIsResultsLoading(false)
            } else {
              genericNoResults("Invalid External Parent type specified")
            }
          } else {
            genericNoResults(
              results ? results.errors : "There was an unexpected problem querying for external parents",
            )
          }
        })
      } else {
        genericNoResults("There was a problem getting a valid token")
      }
    })
  }
}

const _ExternalParentSearch = ({
  externalRuns,
  externalSamples,
  setExternalSamples,
  setExternalRuns,
  buildServerlessQuery,
  externalParent,
  config,
  intl,
}) => {
  const [url, setUrl] = useState("")
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [err, setErr] = useState(null)
  const [isResultsLoading, setIsResultsLoading] = useState(false)
  const [inputValue, setInputValue] = useState("")
  const isDisabled = inputValue.length < 2 || isResultsLoading
  const handleChange = (e) => {
    setInputValue(e.target.value)
  }
  const [isNoResults, setIsNoResults] = useState(false)

  useEffect(() => {
    if (config?.settings && !Object.values(config?.settings).includes(undefined)) {
      setUrl(config.settings.SERVERLESS_URL)
      setUsername(config.settings.SERVERLESS_USERNAME)
      setPassword(config.settings.SERVERLESS_PASSWORD)
    }
  }, [config])

  let getter = []
  let setter = () => {}
  let dropdownId = ""
  let externalParents = {}

  switch (externalParent) {
    case "external_samples":
      externalParents = externalSamples
      getter = externalSamples
      setter = setExternalSamples
      dropdownId = "external-samples-dropdown"
      break

    case "external_runs":
      externalParents = externalRuns
      getter = externalRuns
      setter = setExternalRuns
      dropdownId = "external-runs-dropdown"
      break

    default:
      console.error("Valid external parent not found.")
  }

  return (
    <>
      <div className={"row"} style={{ margin: "0" }}>
        <div className={"col-10"} style={{ padding: "0" }}>
          <Form.Control
            type="text"
            value={inputValue}
            onChange={handleChange}
            placeholder={intl.formatMessage({ id: "general.search" })}
          />
        </div>
        <div className={"col-2"} style={{ padding: "0" }}>
          <Button
            variant={"primary"}
            style={{ width: "100%" }}
            disabled={isDisabled}
            onClick={(e) => {
              e.preventDefault()
              setIsResultsLoading(true)
              setIsNoResults(false)
              setter([])
              updateExternalOptions(
                inputValue,
                externalParent,
                buildServerlessQuery,
                getter,
                setter,
                url,
                username,
                password,
                setIsResultsLoading,
                setIsNoResults,
                setErr,
              )
            }}
          >
            {intl.formatMessage({ id: "general.search" })}
          </Button>
        </div>
      </div>
      <div className={"row"} style={{ margin: "0" }}>
        <div
          className={"col-10"}
          style={{
            margin: "0",
            padding: "0",
          }}
        >
          <p
            className={
              isResultsLoading
                ? " search-results-loading"
                : err
                  ? " error-message"
                  : isNoResults
                    ? " warning-message"
                    : ""
            }
            style={{
              margin: "0",
              paddingLeft: "3px",
              borderRadius: "5px",
              backgroundColor: "var(--lanzalake-white)",
            }}
          >
            {isResultsLoading ? (
              <FormattedMessage id={"general.loading"} defaultMessage={"Loading..."} />
            ) : err ? (
              <>
                <FormattedMessage
                  id={"general.server.error"}
                  defaultMessage={"Error! Could not process request"}
                />
                : {err}
              </>
            ) : isNoResults ? (
              <>
                <FormattedMessage id={"general.results"} defaultMessage={"Results"} />: 0
              </>
            ) : (
              getter.length > 0 && (
                <>
                  <FormattedMessage id={"general.results"} defaultMessage={"Results"} />: {getter.length}
                </>
              )
            )}
          </p>
        </div>
      </div>
    </>
  )
}

export default withApplicationConfig(withFermManagementConfig(_ExternalParentSearch))
